import React from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import { logExceptionIntoSentry, Routes, StudioErrorsEnum } from 'venn-utils';

interface StudioErrorBoundaryProps {
  history: RouteComponentProps['history'];
}

interface StudioErrorBoundaryState {
  hasError: boolean;
}

export class StudioErrorBoundary extends React.Component<
  React.PropsWithChildren<StudioErrorBoundaryProps>,
  StudioErrorBoundaryState
> {
  constructor(props: StudioErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logExceptionIntoSentry(error, errorInfo);

    if (error.message === StudioErrorsEnum.SUBJECT_NO_PERMISSION) {
      const params = new URLSearchParams({
        noPermissions: 'true',
      });
      this.props.history.replace(`${Routes.HOME_PATH}?${params.toString()}`);
    } else {
      // Rethrow error to be caught by the app level error boundary
      throw error;
    }
  }

  render() {
    if (this.state.hasError) {
      // Temporary empty fallback, before this component either handles or rethrows the error
      return null;
    }

    return this.props.children;
  }
}
